import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 19.84 21.75"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m16.97.1-14-.1C1.39 0 .1 1.29.1 2.87h.12H.1l-.1 16c0 1.58 1.29 2.87 2.87 2.87h14.17c.67 0 1.3-.25 1.8-.71.57-.53.9-1.28.9-2.07l.1-16c0-1.58-1.29-2.87-2.87-2.87ZM18 18.97c0 .31-.12.59-.34.79a.9.9 0 0 1-.71.24H2.87c-.62 0-1.13-.51-1.13-1.13l.1-16c0-.62.51-1.13 1.13-1.13v-.12.12l14 .1c.62 0 1.13.51 1.13 1.13z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M13.92 13.18h-8c-.36 0-.64.3-.64.69s.31.69.69.69h8c.38 0 .69-.31.69-.69s-.35-.69-.74-.69M11.97 16.18h-4c-.38 0-.69.31-.69.69s.31.69.69.69h4c.38 0 .69-.31.69-.69s-.31-.69-.69-.69M6.53 7.51l.97.97-.23 1.24c-.12.44.11.85.4 1.05.25.18.7.3 1.1.05l1.19-.56 1.2.64c.16.1.34.15.52.15.21 0 .42-.07.59-.21.27-.21.43-.54.43-.88v-.11l-.24-1.38.97-.97c.3-.3.33-.71.25-.99a1.05 1.05 0 0 0-.69-.74.3.3 0 0 0-.09-.02l-1.38-.24-.55-1.18c-.17-.45-.61-.61-.92-.61s-.74.16-.91.58L8.5 5.5l-1.35.24c-.48.03-.74.39-.83.69-.09.32-.02.68.17.97.02.03.05.06.08.09Zm2.45-.83c.19-.03.35-.15.44-.32l.59-1.1.5 1.07c.09.18.26.31.45.35l1.29.23-.92.92c-.14.14-.21.35-.17.55l.22 1.24-1.12-.6a.6.6 0 0 0-.29-.07c-.09 0-.18.02-.26.06l-1.14.53.22-1.16c.04-.2-.03-.41-.17-.55l-.92-.92 1.29-.23Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }